export default __webpack_public_path__ + "static/media/goblin4.78d0f68d.png";